import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RAccountRuleAdoptionDirty = t.readonly(
  t.type({
    hasPotentialAccountRules: t.boolean,
  }),
);

/*
 * Type.
 */

export interface AccountRuleAdoptionModel extends t.TypeOf<typeof RAccountRuleAdoptionDirty> {}
export const RAccountRuleAdoption = t.clean<AccountRuleAdoptionModel>(RAccountRuleAdoptionDirty);

/*
 * IO methods.
 */

function parseAccountRuleAdoption(src: any): AccountRuleAdoptionModel {
  return {
    hasPotentialAccountRules: src.has_potential_account_rules,
  };
}

/*
 * API type.
 */

export const ApiAccountRuleAdoption = makeApiType(
  'AccountRuleAdoption',
  RAccountRuleAdoption,
  parseAccountRuleAdoption,
);
